type TranslateFn = (key: string, options?: { [key: string]: any }) => string;

type LabeledValue = { value: string; label: string };

export type { TranslateFn };

const configKeyPrefixes: Record<string, string> = {
  dealStages: "crm.config.deal_stages",
  dealCategories: "crm.config.deal_categories",
  noteStatuses: "crm.config.note_statuses",
  taskTypes: "crm.config.task_types",
  companySectors: "crm.config.company_sectors",
};

export const getTranslatedConfigLabel = (
  item: LabeledValue,
  configGroup: keyof typeof configKeyPrefixes,
  translate: TranslateFn,
) => {
  const prefix = configKeyPrefixes[configGroup];
  if (!prefix) return item.label;

  const key = `${prefix}.${item.value}`;
  return translate(key, { _: item.label });
};

export const translateConfigChoices = <T extends LabeledValue>(
  items: T[],
  configGroup: keyof typeof configKeyPrefixes,
  translate: TranslateFn,
) =>
  items.map((item) => ({
    ...item,
    label: getTranslatedConfigLabel(item, configGroup, translate),
  }));
